import { useState } from 'react';
import { LONELINESS_OPTIONS, LONELINESS_QUESTIONS } from '@lessalone/shared';
import { submitGraduation } from '../lib/api';

/**
 * The "step away well" form — the same three UCLA-3 questions, but on
 * submit the membership is graduated and every active conversation closes
 * with endReason='graduated'. The peer is emailed (via the API) so they
 * experience the ending as a small win, not a ghost.
 */
export function GraduationForm({
  communityId,
  onDone,
  onCancel,
}: {
  communityId: string;
  onDone: () => void;
  onCancel: () => void;
}) {
  const [answers, setAnswers] = useState<(number | null)[]>([null, null, null]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const complete = answers.every((value) => value !== null);

  function choose(questionIndex: number, value: number) {
    setAnswers((prev) => prev.map((current, i) => (i === questionIndex ? value : current)));
  }

  async function submit() {
    const [a, b, c] = answers;
    if (a == null || b == null || c == null) return;
    setBusy(true);
    setError(null);
    const result = await submitGraduation(communityId, a, b, c);
    setBusy(false);
    if (result.ok) onDone();
    else setError(result.error);
  }

  return (
    <div className="stack">
      <p className="muted">
        Glad you're feeling better. The same three questions as before — your honest answer is what
        makes the pilot meaningful.
      </p>
      {LONELINESS_QUESTIONS.map((question, index) => (
        <fieldset key={question} className="checkin-q">
          <legend>{question}</legend>
          <div className="checkin-opts">
            {LONELINESS_OPTIONS.map((option) => (
              <label
                key={option.value}
                className={`checkin-opt${answers[index] === option.value ? ' on' : ''}`}
              >
                <input
                  type="radio"
                  name={`grad-q${index}`}
                  checked={answers[index] === option.value}
                  onChange={() => choose(index, option.value)}
                />
                {option.label}
              </label>
            ))}
          </div>
        </fieldset>
      ))}
      <div className="stack-row">
        <button type="button" disabled={!complete || busy} onClick={submit}>
          {busy ? 'Stepping away…' : 'Step away well'}
        </button>
        <button type="button" className="secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
      </div>
      {error && <p className="error">{error}</p>}
    </div>
  );
}
